module.exports = __webpack_public_path__ + "2befc3cb4551b50af71b55277bbd84a8.svg";